<div class="page-container" [class.loading]="isLoading">
    <app-header
        [title]="{ key: 'payroll.taxForms.RL1.employee.edit.title', params: { name: rl1.employee.fullName } }"
        [badgeOptions]="rl1.stateBadge"
        [back]="true"
    ></app-header>

    @if (subset === 'DETAILS' && hasErrors) {
        <ui-banner variant="danger">{{
            'payroll.taxForms.atLeastOneBoxContainsAnErrorOrIsMissingARequiredValueUpdateTheIn' | translate
        }}</ui-banner>
    }

    <div class="flex col w-100 md-w-75">
        @if (subset === 'DETAILS') {
            <app-rl1-form #form [rl1]="rl1" />
        } @else {
            <ui-card>
                <app-tax-return-employee-form #form [taxForm]="rl1" />
            </ui-card>
        }

        <div class="buttons">
            <ui-button (click)="cancel($event)">{{ 'cancel' | translate }} </ui-button>
            <ui-button [disabled]="isLoading" (click)="save()" type="primary">{{ 'save' | translate }} </ui-button>
        </div>
    </div>
</div>
